import React ,{Component} from 'react';
import { Navigate  } from 'react-router-dom';
import axios from 'axios';

import Button from '@mui/material/Button';
import { styled } from '@mui/system';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import TableCell from '@mui/material/TableCell';
import TableSortLabel from '@mui/material/TableSortLabel';
import TablePagination from '@mui/material/TablePagination';
import TableBody from '@mui/material/TableBody'; 

import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import dayjs from 'dayjs';
import { addDays } from "date-fns";
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import Checkbox from '@mui/material/Checkbox'; 
import FormControlLabel from '@mui/material/FormControlLabel'; 

import MailOutlinedIcon from '@mui/icons-material/MailOutlined';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import ReactToPrint from 'react-to-print';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
//import { styled } from '@mui/material/styles';
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
import LocalPrintshopOutlinedIcon from '@mui/icons-material/LocalPrintshopOutlined';
import Uploadfile from './Uploadfile';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
	     import Sharelink from './Sharelink';     
 import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
  import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import Box from '@mui/material/Box';
import StepLabel from '@mui/material/StepLabel';
import Sendemailestimate from './Sendemailestimate';


const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(100%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 100,
});


const useStyles = styled({   
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
  

  table: {
    minWidth: 750,
  },
  
});



function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort(array, cmp) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}


function getSorting(order, orderBy) {
  return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}



export default class Estimateviewmore extends Component {
	
    constructor(props) {
    super(props);
	
 this.state = {open:false, addopen: false,redirect:false,pagename:'',emailid:'',
	 se_reference:'',estimateid:'',se_id:0,se_quotenumber:'',salesshippingamt:0,
	estimatedate:'',productviewData:[],sestatus:'',
	 estimateData:[],page:0 ,prevpage:0,totaldata:0,rowsPerPage:50,rowsPaging:[],
search:'',order:'desc' ,orderBy:'se_id',customername:'',taxbrkupsarr:[],taxsumarr:[],subtotal:"0.00",
	  goodthrudate:'',erropen:false,errortype:"error",errormessage:"",grandtotal:"0.00",prevfile:"",
	urllink:'',	activeStep:0,active:'',setactiveStep:0,invoiceclass:"icon-default",expireclass:"icon-default",entrydate:''
		
	}
	      
	}
	
	

	
	componentWillMount() { 
	
if(localStorage.getItem("ISIuserid")==null)
		 {

		   this.setState({
            redirect: true,
			pagename:'/Login'
          })
		  }
	
	  this.EstimateViewmore();
	

	  
	
	}
 getParameterByName(name, url) {
    if (!url) url = window.location.href;
    url = url.toLowerCase(); 
    name = name.replace(/[\[\]]/g, "\\$&").toLowerCase();
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}



Productapicall(seoid){


	axios.get(localStorage.getItem("ISIurl")+'ajaxestimateproduct.php?action=getall&eop_se_id='+seoid)
     
  .then(resp => {  	
    if(resp.data.length>0){
		
			this.setState({  
			  productviewData: resp.data,  
			   totaldata:parseInt(resp.data[0].count),
			   
			},()=>{this.Taxcalculate();});

     }
	 
	  else{
		   this.setState({productviewData:[],totaldata:0});
	 }
	 
  
    });
}
onSelectedTaxbyid(txid){
	
		 axios.get(localStorage.getItem("ISIurl")+'ajaxtax.php?action=taxid&tx_id='+txid+'&tx_cmp_id='+localStorage.getItem("ISIcmpid")+'&dwt_fromdate='+this.state.entrydate)
  .then(resp => {  
    let strarraytax=[];
	
   if(resp.data.length>0){
	   
  
	
	var rowsArrayp = resp.data;
 
	 rowsArrayp.map((txrow, j) => {
	const taxitems = {
        taxname:txrow.tx_name,
         taxmid:txrow.tx_mainid,
		 taxper:txrow.dwt_percentage,
          taxamt:0 ,
		   taxablevalue:0
        };
		strarraytax.push(taxitems);
		});
		let sretax= this.state.taxsumarr
		let mergedarray = strarraytax.map(function(item) {
    sretax.map(function(item2) {
        if (item.taxmid == item2.Id) {
            item.taxamt=item2.total;
			 item.taxablevalue=((parseFloat(item2.total)*parseFloat(item.taxper))/100).toFixed(2);
			
        }
    });
  return item;
   });

	this.setState({ taxbrkupsarr:mergedarray})


	   
   }
   
   
  });

} 
Taxcalculate(){
	let optionstaxRep = this.state.productviewData;
let profit=0.00,strsubtotal=0.00,strdiscount=0.00;
	
	 var srearray=optionstaxRep.filter(value => value.pr_isdeleted  < 1)
	optionstaxRep  = [].concat(optionstaxRep).sort(function(a, b) {
    return a.taxid > b.taxid ? 1 : -1;
  })
let previoustax="",strcurnttax="",prerow=0,taxablevalue=0,rate="",totaltaxamt=0,taxamount=0,totalamount=0;
	let  strgrantotal=0,strtotaldiscount=0;
	
let strtaxid="",strsep="";

   var result = [];
optionstaxRep.reduce(function(res, value) {

		 
		  	
  if (!res[value.taxid]) {
	
    res[value.taxid] = { Id: value.taxid, total: 0, taxamt: 0 };
    result.push(res[value.taxid])
	if(value.pr_id!="")
	{
		strtaxid=strtaxid+strsep+value.taxid;
		strsep=",";
	}
  }
 
   res[value.taxid].taxamt += parseFloat(value.tax);
  res[value.taxid].total += ((parseFloat(value.salesprice)* parseFloat(value.qty))-parseFloat(value.discount));
  return res;
		 
}, {});
this.onSelectedTaxbyid(strtaxid);


    optionstaxRep.forEach(eachrep => {
		  if(  eachrep.pr_isdeleted !== 1 && eachrep.pr_id !== "" ){
			  
			  strcurnttax=eachrep.taxid;
			  
			  
			 
			strsubtotal  =parseFloat(strsubtotal)+parseFloat(eachrep.total)
	
		strgrantotal=parseFloat(strgrantotal)+parseFloat(eachrep.total)
		profit=parseFloat(profit)+parseFloat(eachrep.costtotal)
		strdiscount=parseFloat(strdiscount)+parseFloat(eachrep.discount)
	
		  }
	});
strgrantotal=parseFloat(strgrantotal)+parseFloat(this.state.salesshippingamt)
	 this.setState({taxsumarr:result,subtotal:parseFloat(strsubtotal).toFixed(2),grandtotal:parseFloat(strgrantotal).toFixed(2),profit:parseFloat(strsubtotal).toFixed(2)-parseFloat(profit).toFixed(2),salesdiscount:strdiscount},()=>{console.log(this.state.pvdata)});
}
handleClickOpen = (e) => { 
  this.setState({open:!this.state.open,
	  });
	  
		
};

handleClickOpen = (e) => { 
  this.setState({addeopn:!this.state.addeopn,
	  });
	  
		
};

EstimateViewmore() {
    let search = window.location.href;
    let Seoid = this.getParameterByName('seoid', search);

    axios.get(localStorage.getItem("ISIurl") + 'ajaxsalesestimate.php?action=getall&se_id=' + Seoid)
        .then(resp => {
            if (resp.data.length > 0) {
               let strname="Sales Estimate: "+resp.data[0].se_quotenumber;
		   
	 this.props.parentdasCallback(
            strname+"~"
        );
		let strsteper="icon-default",strstep3="icon-default";
		if(resp.data[0].se_status==="3")
		{
			strsteper="icon-tick";

		}if(resp.data[0].estimatestatus==="Expired")
		{
			strstep3="icon-tick";

		}
		
                this.setState({
					entrydate:resp.data[0].se_createddate,
					emailid:resp.data[0].cu_emailid,
                    estimateData: resp.data,sestatus:resp.data[0].se_status,
                    se_id:resp.data[0].se_id,se_quotenumber:resp.data[0].se_quotenumber,
					 estimatedate:resp.data[0].estimatedate,
					 reference:resp.data[0].se_reference,salesshippingamt:resp.data[0].se_shippingcharges,
					 customername:resp.data[0].cu_contactname,prevfile:resp.data[0].se_file,
                    goodthrudate:resp.data[0].goodthrudate,invoiceclass:strsteper,expireclass:strstep3
                });
				
				  this.Productapicall(Seoid); 
            } else {
                this.setState({ estimateData: []});
            }
        });
}

 handlAddfileopen = () => {
	
	this.refs.Uploadfile.handleaddfileClose();
}
   handlemailopen = () => {
        const currentUrl = window.location.href; 
        this.setState({ urllink: currentUrl });
        this.setState({ open: true }); 
    }; 
	
	
	   handleCopyLink = () => {
        
        navigator.clipboard.writeText(this.state.urllink)
            .then(() => {
                alert('Link copied!');
this.setState({open:false});				
            })
           
    };

handleClickOpen = (e) => { 
  this.setState({open:!this.state.open
	  });
		
};



handleaddfileClose = (e) => { 
  this.setState({addopen:!this.state.addopen,
	  });
	 		
}

handlestatusupdate = (e) =>{

  let r = window.confirm("Do you really want to Decline?");
		 if(r === true){ 
				 var formData = new FormData(); 
					 formData.append('action','statusupdate')
					formData.append('se_id',this.state.se_id)
					 formData.append('userid',localStorage.getItem("ISIuserid"))
					 formData.append('se_status',5)
				
					  axios.post(localStorage.getItem("ISIurl")+"ajaxsalesestimate.php", 
					  formData, {}).then(res => {
						   this.setState({erropen: true,errormessage:'Status has been Updated',errortype:"success"}); 
						  this.EstimateViewmore();
	                     })
		 
		 }
	
}

handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
  }
  sendEmail = (e) => {
 
    e.preventDefault();
  
    let formData = new FormData();
    formData.append('action', 'sendemail');
    formData.append('se_id', this.state.scn_id);
     formData.append('se_cmp_id' ,localStorage.getItem("ISIcmpid"));
    
    axios.post(localStorage.getItem("ISIurl") + "ajaxsalesestimate.php", formData)
        .then(response => {
           
            console.log("Email sent successfully:", response.data);
			this.setState({activeStep: this.state.activeStep+1});
        })
        .catch(error => {
           
            console.error("Error sending email:", error);
        });
};

Deletesaleestimate = (e) =>{  
  
 
	
		let r = window.confirm("Do you really want to Delete?");
		 if(r === true){ 
				 var formData = new FormData(); 
					 formData.append('action','delete')
					
					 formData.append('se_id',this.state.se_id)
					 formData.append('userid',localStorage.getItem("ISIuserid"))
				
					   axios.post(localStorage.getItem("ISIurl")+"ajaxsalesestimate.php", 
					  formData, {}).then(res => {
						  
						  this.setState({redirect: true,pagename:'/#/Adminsalesestimate'});  
	                     })
						
		 }
 }
formatMoney = (val) => {
  const num = Number(val);
  return isNaN(num) ? "0.00" : num.toFixed(2);
};

	render() {
		
		  if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }
	  let search = window.location.href;
    let Seoid = this.getParameterByName('seoid', search);

		let subtaotal = 0;
		let totalitem=0;
		let totalProfit = 0;
    return (
	
<React.Fragment>	


<p>  <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity={this.state.errortype}
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
  <div className="estimateviewcontainer">
    <div className="estimateviewerleftbox">

        <div className="custgreencolor">
          To: <span className="lighgreencolor">{this.state.customername}</span>
        </div>
        
        <div className="estaddressdata">
          <Table width="100%">
            <tr>		
              <td align="left" style={{"width": "10%"}}>	
                {this.state.estimateData.map((item,index) => { 
                  return (
                    <React.Fragment>
                      <div className="invoiceaddress">
                      
                          <p><b>Invoice Address</b> </p>
                           <p>{item.se_billingaddress1}
                          {item.se_billingaddress2}<br/>
                          {item.se_billingcity} - {item.se_billingpincode}<br/>
                          
                       </p>
                      </div>
                    </React.Fragment>
                  );
                })}
              </td>

              <td align="left" style={{"width": "10%"}}>
                {this.state.estimateData.map((item,index) => { 
                  return (
                    <React.Fragment>
                      <div className="invoiceaddress">
                      
                          <p><b>Delivery Address</b> </p>
                          <p> {item.se_shippingaddress1}<br/>
                       {item.se_shippingaddress2}<br/>
                        {item.se_shippingcity}<br/>
                          {item.se_shippingstate} - {item.se_shippingpincode}<br/>
                          
                       </p>
                      </div>
                    </React.Fragment>
                  );
                })}
              </td>

              <td align="left" style={{"width": "10%"}}> 
                <p><b>Created Date</b></p>
                <p>{this.state.estimatedate}</p>
              </td>

              <td align="left" style={{"width": "10%"}}> 
                <p><b>Expires</b></p>
                <p>{this.state.goodthrudate}</p>
              </td>

              <td align="left" style={{ width: "10%" }}>
                {this.state.reference && (
                  <>
                    <p><b>Reference</b></p>
                    <p>{this.state.reference}</p>
                  </>
                )}
              </td>
            </tr>
          </Table>
        </div>
        
        <div ref={el => (this.componentRef = el)}  >
          <Paper>
            <TableContainer className="table-container">
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell className="table-head" style={{"width":"40%"}} >Item Description</TableCell>
                    <TableCell className="table-head" style={{"width":"5%"}}>Qty</TableCell>
                    <TableCell className="table-head " style={{"width":"10%"}}>Price</TableCell>
                    <TableCell className="table-head " style={{"width":"10%"}}>Discount</TableCell>
                    <TableCell className="table-head " style={{"width":"20%"}}>Tax</TableCell>
                    <TableCell className="table-head " style={{"width":"10%"}}>Sub Total</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {stableSort(this.state.productviewData, getSorting(this.state.orderBy, this.state.order)).map((item, index) => {
                    subtaotal = Number(subtaotal) + Number(item.eop_total);
                    totalitem = Number(totalitem) + Number(item.eop_quantity);
					totalProfit = Number(totalProfit) + Number(item.profit || 0);
                    return (
                      <React.Fragment key={index}>
                        <TableRow className="table-cell" style={{ backgroundColor: '#f1f5f6' }}>
                          <TableCell className="table-cell">
                            <p>{item.eop_description}</p>
                            <p><i>{item.ledgername}({item.le_code})</i></p>
								{item.pr_code!="" &&(
									
							 <p><i>Item Code:{item.pr_code}</i></p>
									)}
                          </TableCell>
                          <TableCell className="table-cell">{item.eop_quantity}</TableCell>
<TableCell className="table-cell">{this.formatMoney(item.eop_price)}</TableCell>
<TableCell className="table-cell">{this.formatMoney(item.eop_discount)}</TableCell>
                          
                          <TableCell className="table-cell"><p> {this.formatMoney(item.eop_taxvalue)}<br/>{item.tx_name}</p> </TableCell>
                          <TableCell className="table-cell">{this.formatMoney(item.eop_total)} $</TableCell>
                        </TableRow>
                      </React.Fragment>
                    );
                  })}


		 {this.state.productviewData.length>0 &&(
				  <React.Fragment>
                  <TableRow>
                    <TableCell colSpan="4"></TableCell>
                    <TableCell><b>Sub Total</b></TableCell>
                    <TableCell align="left">{parseFloat(this.state.subtotal).toFixed(2)}</TableCell>
                  </TableRow>
				  
				   <TableRow>
                    <TableCell colSpan="4"></TableCell>
                    <TableCell><b>Shipping Charges</b></TableCell>
                    <TableCell align="left">{parseFloat(this.state.salesshippingamt).toFixed(2)}</TableCell>
                  </TableRow>
				
  <TableRow>
                    <TableCell colSpan="4"></TableCell>
                    <TableCell><b>Tax Breakdown</b>
						{this.state.taxbrkupsarr.length>0 && (<React.Fragment>
		<div className="taxdiv">
		{this.state.taxbrkupsarr.map((rows,i) => {


				
           return ( <React.Fragment>
		   
		<p ><b>{rows.taxname}: {rows.taxamt}  @ {rows.taxper}%</b></p> 
	
		   </React.Fragment>)
		   
		})}
	</div></React.Fragment>
		)}
					</TableCell>
                    <TableCell align="left">{this.state.taxbrkupsarr.length>0 && (<React.Fragment>
		<div className="taxdiv">
		{this.state.taxbrkupsarr.map((rows,i) => {


				
           return ( <React.Fragment>
		   
		 <p ><b>${rows.taxablevalue}</b></p>
	
		   </React.Fragment>)
		   
		})}
	</div></React.Fragment>
		)}</TableCell>
                  </TableRow>


               


                  <TableRow>
                    <TableCell colSpan="4"></TableCell>
                    <TableCell><b><h4>Total</h4></b>({totalitem}) Items</TableCell>
                    <TableCell align="left">{(parseFloat(this.state.grandtotal)).toFixed(2)} </TableCell>
                  </TableRow>
				  </React.Fragment>
				  )}
				  
				 
				  
				    
				  {this.state.productviewData.length===0 &&(
				  
                 <TableRow>
                 <TableCell  >
                  No Products Found
                  </TableCell>
                </TableRow>

				  )}
  <TableRow>
  <TableCell colSpan="4"></TableCell>
  <TableCell>
    <b>Profit</b>
  </TableCell>
  <TableCell align="left" style={{ color: totalProfit < 0 ? 'red' : 'green' }}>
    {totalProfit.toFixed(2)}
  </TableCell>
</TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
       </div>
      
    </div>

    <div className="estimateviewerightbox">
      
	  <div className="invoiceupdatebox">
	  
		
		<div className="stepperheader">	


<div className="carbon-pod__content"><div className="s1a-timeline-container"><div className="s1a-timeline-pip-container"><span className="carbon-icon s1a-timeline-pip-icon icon-tick" aria-label="created" data-component="icon" data-element="tick" tabindex="0"></span><div className="s1a-timeline-pip-title"><span>created</span></div></div><div className="s1a-timeline-pip-container"><span className="carbon-icon s1a-timeline-pip-icon icon-default" aria-label="sent" data-component="icon" data-element="default"></span><div className="s1a-timeline-pip-title"><span>sent</span></div></div><div className="s1a-timeline-pip-container"><span className="carbon-icon s1a-timeline-pip-icon icon-default" aria-label="viewed" data-component="icon" data-element="default"></span><div className="s1a-timeline-pip-title"><span>viewed</span></div></div>
 {this.state.sestatus==="3" && (
<div className="s1a-timeline-pip-container"><span className={"carbon-icon s1a-timeline-pip-icon "+ this.state.invoiceclass} aria-label="invoiced" data-component="icon" data-element="default"></span><div className="s1a-timeline-pip-title"><span>invoiced</span></div></div>

 )}
 {this.state.sestatus!=="3" && (
<div className="s1a-timeline-pip-container"><span className={"carbon-icon s1a-timeline-pip-icon "+ this.state.expireclass} aria-label="invoiced" data-component="icon" data-element="default"></span><div className="s1a-timeline-pip-title"><span>Expired</span></div></div>
 )}
</div></div>		
		
	  </div>
		 {(this.state.sestatus!=="3" || this.state.sestatus!=="5") && (<div className="createinvoicebox">
	
		  <h3 ><a href={'#/AddSalesinvoice?in_esid='+this.state.se_id}>Create invoice</a></h3>
		   
		  {this.state.sestatus!=="5" && (
		  <h4 onClick={this.handlestatusupdate}>Mark as declined</h4>
		  )}
	
		</div> )}
	  
	  </div>
	  
	  
	  
	  
	  <div className="invoiceupdatebox">
	  
		
		   <div className="Viewfunctionality">
            <ul>
             <li onClick={()=>{this.refs.Sharelink.handlSharebox()}}>
            <p >
                <ShareOutlinedIcon /> &nbsp; Share Link
            </p>
             </li>
			 
			 <li>
            <p >
               <a href={localStorage.getItem("ISIurl")+"uploads/"+this.state.se_quotenumber+".pdf"} target="_blank" ><LocalPrintshopOutlinedIcon className="verticalalign"/> &nbsp; Print Preview
				
				</a>
            </p>  
             </li>
			 
			
             {this.state.sestatus!=="3" && ( 
  <li>
			
            <p  onClick={this.handlAddfileopen}>
			 <AttachFileOutlinedIcon className="verticalalign"/> &nbsp; Add file
			
		   </p>
		  
            
			  </li>	)}
			
			
			
       
			 
			
			  {this.state.prevfile!="" && (
		     <li><p  >
		  <AttachFileOutlinedIcon className="verticalalign"/> <a href={localStorage.getItem("ISIurl")+"uploads/"+this.state.prevfile} target="_blank">View File</a>
		 </p>  </li>)}
			 
		 <li>
            <p onClick={()=>{this.refs.Sendemailestimate.handleaddfileClose()}}>
			
                <MailOutlinedIcon className="verticalalign"/> &nbsp; Email
				
            </p>
             </li>
			 {this.state.sestatus!=="3" && (  <li>
            <p >
             <a href={'/#/AddSalesestimates?seoid='+this.state.se_id} >  <EditOutlinedIcon className="verticalalign"/> &nbsp; Edit</a>
            </p>
             </li>)}
			 
			   <li>
            <p className="icon-text">
              <a  
			    href={localStorage.getItem("ISIurl")+"uploads/"+this.state.se_quotenumber+".pdf"}
                download="uploads/1.pdf" 
                target="_blank"
                rel="noreferrer"  > <CloudDownloadOutlinedIcon />&nbsp; Download</a>
            </p>
			</li>

           <li>
            <p className="icon-text"> <a href={'/#/AddSalesestimates?seoid='+this.state.se_id+'&copy=1'} >
              <ContentCopyOutlinedIcon className="verticalalign"/>&nbsp; Copy</a>
            </p>
			</li>
       <li>
            <p className="icon-text">
              <a  
			    href={localStorage.getItem("ISIurl")+"uploads/packingslip-"+this.state.se_id+".pdf"}
                
                target="_blank"
                rel="noreferrer"  > <LocalShippingOutlinedIcon className="verticalalign"/>&nbsp; Print Packing slip</a>
            </p>
			</li>
			<li>
            <p className="icon-text">
              <a  
	onClick={this.Deletesaleestimate}
               
                rel="noreferrer"  > <DeleteOutlineOutlinedIcon className="verticalalign"/>&nbsp; Delete</a>
            </p>
			</li>
		 
			
             </ul>
			 <div className="clear"></div>
               </div>

	  </div>
	  
	  
	  
    </div>
  </div>

  <div className="clear"></div>
  

  
 <Sharelink ref="Sharelink"  pagevalue={1} id={this.state.se_id} />
  



  <div className="addfile">

        
            
			  
			   <Uploadfile ref="Uploadfile" id={this.state.se_id}  strrtype={1}/>
			 
             <Sendemailestimate ref="Sendemailestimate"  headingname="Sales Estimate"
  
  id={this.state.se_id}  aoid="10"  emailid={this.state.emailid}/>
      

  
</div>
  
</React.Fragment>
    );
}

}